import React, { useContext } from 'react';
import { Grid } from '@elliemae/ds-grid';
import { ControlledDateTimePickerContext } from '../../ControlledDateTimePickerCTX.js';
import { HHInput } from './HHInput.js';
import { MinutesInput } from './MinutesInput.js';
import { MeridiemInput } from './MeridiemInput.js';
import { useTimeInputs } from './useTimeInputs.js';
import { fixedValues } from '../config.js';
import { StyledColonSeparator, StyledSeparator, StyledFocusWithIn } from '../Styleds.js';

export const TimeInputs = (): JSX.Element => {
  const {
    autoFocusHourInput,
    disabled,
    applyAriaDisabled,
    onHoursChange,
    onMinutesChange,
    onMeridiemChange,
    onHoursBlur,
    onMinutesBlur,
    onMeridiemBlur,
    onHoursFocus,
    onMeridiemFocus,
    onMinutesFocus,
    onHoursKeyDown,
    onMinutesKeyDown,
    onMeridiemKeyDown,
  } = useTimeInputs();

  // we do this here so HHInput,MinutesInput, MeridiemInput can be pure components memoized via React.memo
  const {
    hours,
    minutes,
    meridiem,
    hourInputRef,
    minutesInputRef,
    meridiemInputRef,
    latestInteractionRegion,
    currFocusDescriber,
    getProps,
    props: { tabIndex, readOnly },
  } = useContext(ControlledDateTimePickerContext);

  return (
    <Grid
      cols={[
        fixedValues.smallInputWidth,
        fixedValues.separatorWidth,
        fixedValues.smallInputWidth,
        fixedValues.separatorWidth,
        fixedValues.smallInputWidth,
      ]}
    >
      <StyledFocusWithIn>
        <HHInput
          value={hours}
          onChange={onHoursChange}
          onBlur={onHoursBlur}
          onFocus={onHoursFocus}
          onKeyDown={onHoursKeyDown}
          contextRef={hourInputRef}
          tabIndex={tabIndex}
          placeholder="HH"
          autoFocusHourInput={autoFocusHourInput}
          disabled={disabled}
          aria-disabled={applyAriaDisabled}
          applyAriaDisabled={applyAriaDisabled}
          isFocused={latestInteractionRegion === 'time-inputs' && currFocusDescriber === 'hour-input'}
          getProps={getProps}
          readOnly={readOnly}
        />
      </StyledFocusWithIn>
      <StyledColonSeparator alignItems="center">:</StyledColonSeparator>
      <StyledFocusWithIn>
        <MinutesInput
          value={minutes}
          onChange={onMinutesChange}
          onBlur={onMinutesBlur}
          onFocus={onMinutesFocus}
          onKeyDown={onMinutesKeyDown}
          contextRef={minutesInputRef}
          tabIndex={tabIndex}
          placeholder="MM"
          disabled={disabled}
          aria-disabled={applyAriaDisabled}
          applyAriaDisabled={applyAriaDisabled}
          isFocused={latestInteractionRegion === 'time-inputs' && currFocusDescriber === 'minute-input'}
          getProps={getProps}
          readOnly={readOnly}
        />
      </StyledFocusWithIn>
      <StyledSeparator> </StyledSeparator>
      <StyledFocusWithIn>
        <MeridiemInput
          value={meridiem}
          onChange={onMeridiemChange}
          onBlur={onMeridiemBlur}
          onFocus={onMeridiemFocus}
          onKeyDown={onMeridiemKeyDown}
          contextRef={meridiemInputRef}
          tabIndex={tabIndex}
          placeholder="AM"
          disabled={disabled}
          aria-disabled={applyAriaDisabled}
          applyAriaDisabled={applyAriaDisabled}
          isFocused={latestInteractionRegion === 'time-inputs' && currFocusDescriber === 'meridiem-input'}
          getProps={getProps}
          readOnly={readOnly}
        />
      </StyledFocusWithIn>
    </Grid>
  );
};
